"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * The default renderer for the input label, used if no inputRenderer is provided
 * @param fileOrFiles The value of the file input element, can be a single File, or a FileList object
 * @returns {string} The string to be used in the file name span element. The File name if a single file, junction of File names if multiple are selected, or the root folder if a directory is selected
 */
var defaultRenderer = function defaultRenderer(fileOrFiles) {
  if (!fileOrFiles) {
    return '';
  }

  /* Check if value is a FileList object */
  var isFileList = fileOrFiles instanceof FileList;

  /* If value is defined and is not a FileList, it is a single File object */
  if (!isFileList) {
    /* Set label to singular selected file name */
    return fileOrFiles.name;
  }

  /* If value is defined, is a FileList and has elements inside */
  if (isFileList && fileOrFiles.length > 0) {
    /* Check if items contain webkitRelativePath prop. If true, then a directory was selected. If not, multiple files were selected */
    var relativeRootFolderPath = fileOrFiles[0].webkitRelativePath;
    return relativeRootFolderPath
    /* Set label to root folder name */ ? relativeRootFolderPath.split('/')[0]
    /* Set label to junction of file names */ : Array.from(fileOrFiles).map(function (aValue) {
      return aValue.name;
    }).join(', ');
  }

  /* If FileList object is empty, return empty string for label */
  return '';
};
var defaultProps = {
  placeholder: 'No file chosen',
  inputRenderer: defaultRenderer,
  parseFileAsText: false,
  onChange: function onChange() {},
  disabled: false,
  isValid: true,
  theme: {
    TextField: {},
    Spinner: {}
  },
  validateOn: 'change',
  multiple: false,
  directory: false
};

/**
 * Provides a component used to upload files.
 */
var FileUploader = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(FileUploader, _Component);
  function FileUploader(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FileUploader);
    _this = _callSuper(this, FileUploader, [props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "refInput", function (element) {
      _this.inputEl = element;
    });
    /**
     * Creates the label for the input based on multiple/directory prop values
     * @returns {string} The label for the input button
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "generateButtonLabel", function () {
      var _this$props = _this.props,
        multiple = _this$props.multiple,
        directory = _this$props.directory;
      if (multiple) {
        return 'Choose files';
      }
      if (directory) {
        return 'Choose folder';
      }
      return 'Choose file';
    });
    _this.state = {
      value: props.value,
      displayValue: props.inputRenderer(props.value)
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setValue = _this.setValue.bind((0, _assertThisInitialized2["default"])(_this));
    _this.parseText = _this.parseText.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(FileUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /**
       * This is necessary until repo react version is upgraded to 16
       * React 15 and previous versions do not allow non-whitelisted props to be passed into DOM element
       * This is a workaround to get the props on the elements
       * Conditional statements are present because, if the props are in the element (even if set to false), they take effect
       */
      if (this.props.multiple) {
        this.inputEl.setAttribute('multiple', this.props.multiple);
      }
      if (this.props.directory) {
        this.inputEl.setAttribute('directory', this.props.directory);
        this.inputEl.setAttribute('webkitdirectory', this.props.directory);
      }
    }

    /**
     * Handle `displayValue` change when `value` has changed
     * https://www.mulesoft.org/jira/browse/UIFX-1082
     */
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (newProps.value !== this.state.value) {
        this.setValue(newProps.value);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState) {
      if (previousState.value !== this.state.value) {
        var onChange = this.props.onChange;
        onChange({
          value: this.state.value
        });
      }
    }
  }, {
    key: "setValue",
    value: function setValue(valueToSet) {
      this.setState({
        value: valueToSet,
        displayValue: this.props.inputRenderer(valueToSet)
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.inputEl.click();
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props2 = this.props,
        parseFileAsText = _this$props2.parseFileAsText,
        multiple = _this$props2.multiple,
        directory = _this$props2.directory;
      var dirOrMultiple = directory || multiple;
      var target = event.currentTarget || event.srcElement;
      /** If dirOrMultiple abd parseFileAsText, then call parseMultipleAsText **/
      if (dirOrMultiple) {
        var files = target.files ? target.files : [];
        if (parseFileAsText) {
          this.parseMultipleAsText(files);
        } else {
          this.setValue(files);
        }
      } else {
        var file = target.files ? target.files[0] : {};
        if (parseFileAsText) {
          this.parseText(file);
        } else {
          this.setValue(file);
        }
      }
    }
  }, {
    key: "parseText",
    value: function parseText(file) {
      var _this2 = this;
      var reader = new window.FileReader();
      var localFile = file;
      reader.onload = function (e) {
        localFile.value = e.target.result;
        _this2.setValue(localFile);
      };
      reader.readAsText(file);
    }

    /**
     * Parses all the files selected into text. When the reader finishes loading a file, the result is added to the `value`
     * attribute of the state, which would be an array of strings in this case
     * @param files The files the user selected and should be parsed into text
     */
  }, {
    key: "parseMultipleAsText",
    value: function parseMultipleAsText(files) {
      var _this3 = this;
      var reader = new window.FileReader();
      reader.onload = function (e) {
        _this3.appendParsedFile(e.target.result);
      };

      /* Set state to have value as an empty array, in order to later append parsed files to this array */
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        value: []
      }));
      files.forEach(reader.readAsText);
    }

    /**
     * Append a file that was parsed as text to the `value` property of the state
     * @param fileParsedAsText The string corresponding to the file after being parsed to text
     */
  }, {
    key: "appendParsedFile",
    value: function appendParsedFile(fileParsedAsText) {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        value: this.state.value.append(fileParsedAsText)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        id = _this$props3.id,
        fileType = _this$props3.fileType,
        placeholder = _this$props3.placeholder,
        disabled = _this$props3.disabled,
        theme = _this$props3.theme,
        className = _this$props3.className,
        isDirty = _this$props3.isDirty,
        isValid = _this$props3.isValid,
        isLoading = _this$props3.isLoading,
        isPending = _this$props3.isPending,
        isFocused = _this$props3.isFocused,
        testId = _this$props3.testId,
        size = _this$props3.size,
        multiple = _this$props3.multiple,
        refCallback = _this$props3.refCallback,
        ariaLabel = _this$props3['aria-label'],
        ariaLabelledBy = _this$props3['aria-labelledby'],
        ariaDescribedBy = _this$props3['aria-describedby'];
      var displayValue = this.state.displayValue;
      var directory = this.props.directory ? this.props.directory.toString() : undefined;
      var uploaderClasses = (0, _classnames["default"])(theme.fileUploader, className, disabled && theme.isDisabled, isDirty && theme.isDirty, isFocused && theme.isFocused, isValid && theme.isValid, !isValid && theme.hasError, size ? theme["form-size-".concat(size)] : '');
      var filenameClasses = (0, _classnames["default"])(theme.filename, !displayValue && theme.empty);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: uploaderClasses,
        "data-test-id": testId,
        "data-anypoint-component": FileUploader.displayName,
        title: displayValue,
        "aria-disabled": disabled,
        ref: function ref(node) {
          if (refCallback && typeof refCallback === 'function') {
            refCallback(node);
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: "".concat(id, "-input"),
        ref: this.refInput,
        type: "file"
        // Remove from DOM for accessiblity and visual reasons
        ,
        style: {
          display: 'none'
        },
        accept: fileType,
        onChange: this.handleChange,
        "data-test-id": testId && "".concat(testId, "-input"),
        multiple: multiple,
        directory: directory,
        webkitdirectory: directory
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: filenameClasses,
        id: "".concat(id, "-file-name")
        // eslint-disable-next-line jsx-a11y/aria-proptypes
        ,
        "aria-invalid": !isValid
        // Aria-labelledby will always overwrite aria-label
        // A form label is required. Therefore, aria-label will never be
        // resolved as the element name in the browser accessiblity tree
        ,
        "aria-label": ariaLabel
        // aria-labelledby property has the highest precedence when browsers calculate accessible names
        ,
        "aria-labelledby": ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(id, "-file-name") : "".concat(id, "-file-name"),
        "aria-describedby": ariaDescribedBy
      }, displayValue || placeholder), isPending || isLoading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        testId: testId && "".concat(testId, "-spinner"),
        size: "s",
        className: theme.spinner,
        theme: theme.Spinner
      }) : null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "".concat(id, "-button"),
        testId: testId && "".concat(testId, "-button"),
        className: theme.fileUploaderButton,
        kind: "tertiary",
        noFill: true,
        size: "sm",
        onClick: this.handleClick,
        disabled: disabled,
        type: "button",
        theme: (0, _typeof2["default"])(theme.Button) === 'object' ? theme.Button : undefined
      }, this.generateButtonLabel()));
    }
  }]);
  return FileUploader;
}(_react.Component);
(0, _defineProperty2["default"])(FileUploader, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(FileUploader, "displayName", 'FileUploader');
//# sourceMappingURL=FileUploader.js.map